import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { IProposal, IProposalsResult } from 'interfaces/proposals/proposal';
import { AppThunk } from 'app/store/store';
import { getPosts } from 'services/posts-service'
const shufflePromoted = process.env.SHUFFLE_PROMOTED || 0;

type PostsState = {
  posts: any[]
  promotedPosts: any[],
  displayablePosts: any[],
  batchIndex: number
  lastAuthor: string;
  lastPermlink: string;
  isLoading: boolean,
  error: string | null,
  hasMore: boolean,
  currentFilter: string,
  currentTag: string
}

const postsInitialState: PostsState = {
  posts: [],
  promotedPosts: [],
  displayablePosts: [],
  batchIndex: 0,
  lastAuthor: '',
  lastPermlink: '',
  isLoading: true,
  error: null,
  hasMore: true,
  currentFilter: '',
  currentTag: ''
}

function startLoading(state: PostsState) {
  state.isLoading = true
  state.displayablePosts = []
}

function loadingFailed(state: PostsState, action: PayloadAction<string>) {
  state.isLoading = false
  state.error = action.payload
}
// function buildDisplayablePosts(
//   posts: any[],
//   promoted: any[],
//   limit: number
// ) {
//   const result = [];
//   const batches = Math.ceil(posts.length / limit);

//   for (let i = 0; i < batches; i++) {
//     const start = i * limit;
//     const end = start + limit;

//     if (promoted[i]) {
//       result.push({
//         ...promoted[i],
//         __isPromoted: true
//       });
//     }

//     result.push(...posts.slice(start, end));
//   }

//   return result;
// }


// function buildDisplayablePostsIncremental(
//   existing: any[],
//   newPosts: any[],
//   promoted: any[],
//   limit: number,
//   batchIndex: number
// ) {
//   const result = [...existing];
//   let localBatch = batchIndex;

//   // contar posts reales ya renderizados
//   let realPostCount = existing.reduce(
//     (acc, p) => acc + (p.__isPromoted ? 0 : 1),
//     0
//   );

//   for (const post of newPosts) {
//     if (
//       realPostCount > 0 &&
//       realPostCount % limit === 0 &&
//       promoted[localBatch]
//     ) {
//       result.push({
//         ...promoted[localBatch],
//         __isPromoted: true
//       });
//       localBatch++;
//     }

//     result.push(post);
//     realPostCount++;
//   }

//   return {
//     result,
//     nextBatchIndex: localBatch
//   };
// }

function buildDisplayablePostsIncremental(
  existing: any[],
  newPosts: any[],
  promoted: any[],
  limit: number,
  batchIndex: number
) {
  const result = [...existing];
  let localBatch = batchIndex;

  let realPostCount = existing.reduce(
    (acc, p) => acc + (p.__isPromoted ? 0 : 1),
    0
  );

  for (const post of newPosts) {
    if (
      (realPostCount === 0 || realPostCount % limit === 0) &&
      promoted[localBatch]
    ) {
      result.push({
        ...promoted[localBatch],
        __isPromoted: true
      });
      localBatch++;
    }

    result.push(post);
    realPostCount++;
  }

  return {
    result,
    nextBatchIndex: localBatch
  };
}


function postKey(post: any) {
  return `${post.author}/${post.permlink}`;
}

function dedupePosts(existing: any[], incoming: any[]) {
  const existingKeys = new Set(existing.map(postKey));
  return incoming.filter(p => !existingKeys.has(postKey(p)));
}


const posts = createSlice({
  name: 'posts',
  initialState: postsInitialState,
  reducers: {
    getPostsStart: startLoading,
    getPostsSuccess(state, { payload }) {
      const { posts, promotedPosts, hasMore } = payload;

      state.posts = dedupePosts([], posts);
      state.promotedPosts = dedupePosts([], promotedPosts || []);
      state.batchIndex = 0;

      const built = buildDisplayablePostsIncremental(
        [],
        state.posts,
        state.promotedPosts,
        20,
        0
      );

      state.displayablePosts = built.result;
      state.batchIndex = built.nextBatchIndex;

      state.hasMore = hasMore;
      state.isLoading = false;
      state.currentFilter = payload.filter;
      state.currentTag = payload.tag;
    },
    getMorePostsSuccess(state, { payload }) {
      const { posts, lastAuthor, lastPermlink, hasMore } = payload;

      const newPosts = dedupePosts(state.posts, posts);
      if (newPosts.length === 0) {
        state.hasMore = hasMore;
        state.isLoading = false;
        return;
      }

      state.posts.push(...newPosts);

      const built = buildDisplayablePostsIncremental(
        state.displayablePosts,
        newPosts,
        state.promotedPosts,
        20,
        state.batchIndex
      );

      state.displayablePosts = built.result;
      state.batchIndex = built.nextBatchIndex;

      state.lastAuthor = lastAuthor;
      state.lastPermlink = lastPermlink;
      state.hasMore = hasMore;
      state.isLoading = false;
    },

    getPostsFailure: loadingFailed,
  }
});

function shuffleArray(array: any[]) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
export const {
  getPostsStart,
  getPostsSuccess,
  getMorePostsSuccess,
  getPostsFailure,
} = posts.actions;
export default posts.reducer;
export const fetchPosts = (
  tag: string,
  filter: string = "trending",
  resetPagination = false,
  firstLoad = false,
  limit = 20,
  videoOnly = true,
  username: string = ""
): AppThunk => async (dispatch, getState) => {
  try {
    dispatch(getPostsStart());
    // let multipleTags = false; 
    const { posts: { lastAuthor, lastPermlink } } = getState();

    let postsData = await getPosts(
      limit,
      tag,
      filter,
      resetPagination,
      resetPagination ? '' : lastAuthor,
      resetPagination ? '' : lastPermlink,
      "get_ranked_posts",
      videoOnly,
      username
    );
    let promotedData = [];

    if (firstLoad) {
      const promoted = await getPosts(
        20,//max promoted posts batch
        "",
        "promoted",
        true,
        "",
        "",
        "get_ranked_posts",
        false
      );
      if (shufflePromoted) {
        promotedData = shuffleArray(promoted?.posts) || [];
      } else {
        promotedData = promoted?.posts || [];
      }

    }
    // if (!postsData || !postsData.posts) {
    //   dispatch(getPostsSuccess({
    //     posts: [],
    //     lastAuthor: '',
    //     lastPermlink: '',
    //     hasMore: false,
    //     firstLoad
    //   }));
    //   return;
    // }
    const postsList = postsData?.posts ?? [];
    const lastAuthorSafe = postsData?.lastAuthor ?? '';
    const lastPermlinkSafe = postsData?.lastPermlink ?? '';
    const hasMoreSafe = postsData?.hasMore ?? false;

    dispatch(getPostsSuccess({
      posts: postsList,
      promotedPosts: promotedData,
      lastAuthor: lastAuthorSafe,
      lastPermlink: lastPermlinkSafe,
      hasMore: hasMoreSafe,
      firstLoad,
      filter,
      tag
    }));
  } catch (err) {
    dispatch(getPostsFailure(err.toString()));
  }
};